import { client } from "api";
import { Order } from "models/Order";

export type GetAllCustomersRequest = { search?: string | null };

export type GetAllCustomersResponse = Pick<Order, "companyCode" | "companyName">[];

export const getAllCustomers = ({
  search,
}: GetAllCustomersRequest): Promise<GetAllCustomersResponse> =>
  client.get<GetAllCustomersResponse>(`/customer`, { params: { search } }).then((res) => res.data);
